import Immutable from 'immutable';

import FileInfoScreen from 'sharedreact/data/FileInfoScreen';

const Content: {
  name: string | null,
  screens: Immutable.List<FileInfoScreen> | null
} = {
  name: null,
  screens: null
};

class FileInfoScreenSet extends Immutable.Record(Content) {
}

export default FileInfoScreenSet;
